/**
 * Fixed dimension constants for recorder UI components.
 *
 * These are layout values that don't change with brand customization.
 * Colors come from MUI theme or status constants instead.
 */

export const CONTROL_BAR = {
  height: '48px',
  borderRadius: {
    small: '8px',
    medium: '12px',
    large: '16px',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
  },
  button: {
    size: {
      small: '20px',
      medium: '30px',
      large: '36px',
    },
  },
} as const;

export const WAVEFORM = {
  height: '16px',
  barWidth: '2px',
  gap: '2px',
} as const;

export const MENU_Z_INDEX = 1000000;
export const TOOLTIP_Z_INDEX = 1000002;
export const MENU_WIDTH_PX = 240;
